import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderCell } from './DocFlowSelectModalTableRow.utils'

import * as styles from './DocFlowSelectModalTableRow.module.css'

function DocFlowSelectModalTableRow({
  Actions = TableRowActions,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  isSelected,
  item,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions({ ...restProps, item })

  const rowClass = useTableRowModClassName({
    className: styles.DocFlowSelectModalTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={rowClass}
      key={item.id}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          checked={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            item,
            name: column.name,
            t,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default DocFlowSelectModalTableRow
